import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    let $parentAsideElement = this.element.querySelector('aside#filters-canvas');

    if (!$parentAsideElement)
      return;

    $('.select2').select2({
      language: "pt-BR",
      placeholder: 'Todos',
      allowClear: true,
      multiple: true,
      width: '500px',
      dropdownParent: $parentAsideElement
    });
  }
}